import { createSelector } from 'reselect'
import { NAME } from './constants'

export const getNoteList = createSelector(
  (state) => state[NAME],
  (notes) => notes.notes
)

export const noteMax = createSelector(
  (state) => state[NAME],
  (notes) => notes.noteMax
)

export const getDates = createSelector(
  (state) => state[NAME],
  (notes) => notes.dates
)

export const isNoteExpanded = createSelector(
  [(state) => state[NAME], (_, id) => id],
  (notes, id) => notes.noteExpand[id]
)

export const getPostNote = createSelector(
  (state) => state[NAME],
  (notes) => notes.postNote
)

export const getNoteError = createSelector(
  (state) => state[NAME],
  (notes) => notes.errors
)

export const canPostNote = createSelector(
  (state) => state[NAME],
  (notes) => notes.canPostNote
)

export const isPostingNote = createSelector(
  (state) => state[NAME],
  (notes) => notes.postingNote
)

export const noteLoading = createSelector(
  (state) => state[NAME],
  (notes) => notes.loadingNote
)
export const filterStr = createSelector(
  (state) => state[NAME],
  (notes) => notes.filterStr
)
